import { CUSTOMER_API_HEADERS, SHOPIFY_HEADERS } from "@smartrr/shared/constants";
import { ReqMiddleware } from "@smartrr/shared/req";
import { TypedFrontendCustomerApi } from "@smartrr/shared/typedCustomerApi/TypedCustomerRoutes";
import { getFromLocalStorage } from "@smartrr/shared/utils/localStorageAccess";

import { store } from "@customer-app/state/store";
import { isAdminPreviewingAsCustomer } from "@customer-app/state/reducers/auth";

const customerPortalMiddleware: ReqMiddleware = (endpoint, requestConfig) => {
  const validation = store.getState().auth.validation;
  const previewingAdminShopifyId = isAdminPreviewingAsCustomer();

  // must be done as this is a CORS request
  requestConfig.credentials = "omit";

  if (validation?.hasSignature) {
    const customerShopifyId = validation.shopifyId;
    if (!customerShopifyId) {
      throw new Error("customer does not have Shopify ID");
    }

    requestConfig.headers = {
      ...requestConfig.headers,
      [CUSTOMER_API_HEADERS.SHOPIFY_CUSTOMER_ID]: customerShopifyId,
      [SHOPIFY_HEADERS.SHOP_DOMAIN]: validation.hasSignature ? validation.myShopifyDomain : "",
      [CUSTOMER_API_HEADERS.SIGNATURE]: validation.signature,
      [CUSTOMER_API_HEADERS.EXPIRATION]: validation.exp,
    };

    if (previewingAdminShopifyId) {
      requestConfig.headers = {
        ...requestConfig.headers,
        [CUSTOMER_API_HEADERS.ADMIN_PREVIEW_ID]: previewingAdminShopifyId,
      };
    }
  }

  const overrideHeadersJson = getFromLocalStorage("ADMIN_OVERRIDE_HEADERS");
  if (overrideHeadersJson) {
    const overrideHeaders = JSON.parse(overrideHeadersJson);
    requestConfig.headers = {
      ...requestConfig.headers,
      ...overrideHeaders,
    };
  }

  return requestConfig;
};

export const typedCustomerFrontendApi = new TypedFrontendCustomerApi([customerPortalMiddleware]);
